import React, { useState, useContext } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { FormattedMessage } from "react-intl";

import UserContext from "../contexts/user";
import EventContext from "../contexts/event";

import SidebarMain from "../components/sidebar-main";
import SchedulePresentation from "../components/schedule/presentation";
import MySchedulePresentation from "../components/schedule/mypresentation"

import { EventData, Presentation } from "../types/presentation";
import EditProfileModal from "../components/edit-profile-modal";
import LocaleSwitcher from "../components/locale-switcher";
import PresentationItem from "../components/speaker/presentationItem";


const ScheduleFallback: React.FC<{ message: string }> = ({ message }) => (
  <Container className="p-4">
    <div className="text-center">
      <h5>Unable to load schedule</h5>
      <p>{message}</p>
    </div>
  </Container>
);

const Schedule: React.FC<{
  isSpeaker?: boolean;
  eventData: EventData;
  locale: string;
  setLocale: (arg0: string) => void;
  setSchedule?: string;
  mySchedule?: boolean;
}> = ({ eventData, locale, setLocale, isSpeaker, setSchedule, mySchedule }) => {
  const location = useLocation();
  const userContext = useContext(UserContext);
  const eventContext = useContext(EventContext);
  const [isVirtual] = useState(
    queryString.parse(location.search).viewmode === "virtual"
  );
  const [isIframe] = useState(queryString.parse(location.search).iframe);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [pres, setPres] = useState<Presentation>();
  const [eventPresentations, setEventPresentations] = useState<Presentation[]>(
    Array.isArray(eventData?.presentations) ? eventData.presentations : []
  );
  const currentUrl = window.location.href;

  

  const show_video_views = eventData?.event?.show_video_views;
  const [filter, setFilter] = useState<{
    speakers: Array<string>;
    rooms: Array<string>;
    associations: Array<string>;
    dates: Array<string>;
    activeQuizzesOnly: boolean;
  }>({
    speakers: [],
    rooms: [],
    associations: [],
    dates: [],
    activeQuizzesOnly: false,
  });
  let previousDate: string | null = null;
  const days = (eventData?.aggregates?.dates || [])
    .slice()
    .sort((a: string, b: string) => a.localeCompare(b));

  const updatePresentation = (presentation: any) => {


    var eventPresentationsClone = eventPresentations.map(function (presentationItem) {

      if (presentationItem._id === presentation._id) {
        presentationItem.users = presentation.users
      }
      return presentationItem

    });

    setEventPresentations(eventPresentationsClone)

  }
  console.log("eventPresentations", eventPresentations,)
  console.log("env testing", process.env.REACT_APP_VISIO)

  if (!eventData?.event || !eventData?.aggregates) {
    return <ScheduleFallback message="Event details are not available right now. Please refresh and try again." />;
  }

  return (
    <div className="home-container-with-login">
      {currentUrl === `http://localhost:3000/videoeditor` ||
        currentUrl === `https://dl24mgqtntz00.cloudfront.net/videoeditor` ||
        currentUrl === `https://d3jflgxijbakjm.cloudfront.net/videoeditor` ||
        currentUrl === `https://d3qxxjgfo8xb94.cloudfront.net/videoeditor`
        ? null :
        //staging env url and the url which come when checking the project in staging is different, why tho?.
        <div
          className={`grid-contianer ${isIframe ? "iframe-mode-container" : ""}`}
        >
          <LocaleSwitcher locale={locale} setLocale={setLocale} />
          {/* <div className="sidebar curve"> */}
          <SidebarMain
            event={eventData.event}
            aggregates={eventData.aggregates}
            filter={filter}
            setFilter={setFilter}
            openProfileModal={openProfileModal}
            setOpenProfileModal={setOpenProfileModal}
            setSchedule={setSchedule}
            presentations={eventData.presentations}
          />
          {/* </div> */}

          <div className="main p-t-50">
            <Container>
              {isIframe && (
                <Row className="top-menu-container m-b-20">
                  <Col md={4}></Col>
                  <Col>
                    <div className="top-menu pad-0 top-menu-mob">
                      <Button
                        className={`nav-link ${filter.activeQuizzesOnly ? "" : "active"
                          }`}
                        onClick={() =>
                          setFilter({ ...filter, activeQuizzesOnly: false })
                        }
                      >
                        <img src="/icons/schedule-ico.svg" alt="schedule" />
                        <span className="text">
                          <FormattedMessage id="menu.schedule" />
                        </span>
                      </Button>
                      <Button
                        className="nav-link d-none d-lg-block"
                        onClick={() => alert("work in progress")}
                      >
                        <img src="/icons/synopsis-ico.svg" alt="Synopsis" />
                        <span className="text">
                          <FormattedMessage id="menu.synopsis" />
                        </span>
                      </Button>
                      {userContext.user ? (
                        <>
                          <Button
                            className="nav-link"
                            onClick={() => setOpenProfileModal(!openProfileModal)}
                          >
                            <img src="/icons/profile-ico.svg" alt="PROFILE" />
                            <span className="text">
                              <FormattedMessage id="menu.profile" />
                            </span>
                          </Button>
                          <Button
                            className="nav-link"
                            onClick={() => {
                              userContext.setListUser(
                                JSON.stringify({ id: "", token: "" })
                              );
                            }}
                            to="#"
                          >
                            <img src="/icons/profile-ico.svg" alt="PROFILE" />
                            <span className="profile-tick"></span>
                            <span className="text">
                              <FormattedMessage id="menu.logout" />
                            </span>
                          </Button>
                        </>
                      ) : (
                        (eventData.event.quiz ||
                          eventData.event.forum ||
                          eventData.aggregates.rooms.length > 1) && (
                          <Button
                            className="nav-link"
                            onClick={() => {
                              const currentPath = window.location.pathname;
                              window.location.href = `${currentPath}?tab=connexion`; // Diljith krishna added this to use tab=connexion is  , 29/01/2026
                            }}                          > 
                            <img src="/icons/profile-ico.svg" alt="Login" />
                            <span className="text">
                              <FormattedMessage id="menu.login" />
                            </span>
                          </Button>
                        )
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              <Row>
                <Col className="schedule_page_padding">
                  {(() => {
                    try {
                      return eventPresentations
                        .filter((presentation) =>
                          filter.speakers.length
                            ? filter.speakers.indexOf(
                              presentation?.speaker_info?._id || ""
                            ) !== -1
                            : true
                        )
                        .filter((presentation) => {
                          if (isSpeaker) {
                            return presentation.speaker_id == userContext.user?.speaker_id;
                          }
                          return true;
                        })
                        .filter((presentation) =>
                          filter.rooms.length
                            ? filter.rooms.indexOf(presentation?.room_info?._id || "") !== -1
                            : true
                        )
                        .filter((presentation) =>
                          filter.associations.length
                            ? filter.associations.indexOf(
                              presentation?.association_info?._id || ""
                            ) !== -1
                            : true
                        )
                        .filter((presentation) =>
                          filter.dates.length
                            ? filter.dates.indexOf(presentation?.date || "") !== -1
                            : true
                        )
                        .sort((a, b) => {
                          const dateA = new Date(a?.date || "");
                          dateA.setMinutes(a?.time || 0);
                          const dateB = new Date(b?.date || "");
                          dateB.setMinutes(b?.time || 0);

                          if (dateA.getTime() < dateB.getTime()) return -1;
                          if (dateA.getTime() > dateB.getTime()) return 1;
                          return 0;
                        })
                        .map((presentation) => {
                          if (previousDate === presentation.date) {
                            return presentation;
                          }

                          previousDate = presentation.date;
                          return {
                            ...presentation,
                            header: isVirtual ? false : true,
                            day: days.indexOf(presentation.date) + 1,
                          };
                        })
                        .filter((presentation) =>
                          filter.activeQuizzesOnly
                            ? eventContext.presentationsWithQuestions.indexOf(
                              presentation._id
                            ) > -1
                            : true
                        )
                        .map((presentation) => (
                          <React.Fragment key={presentation._id}>
                            {isSpeaker ? (
                              <PresentationItem
                                presentation={presentation}
                                isVirtual={isVirtual}
                                show_video_views={show_video_views}
                                showAgenda={(eventData?.aggregates?.rooms || []).length > 1}
                              />
                            ) : mySchedule ? (
                              <MySchedulePresentation
                                presentation={presentation}
                                isVirtual={isVirtual}
                                show_video_views={show_video_views}
                                showAgenda={(eventData?.aggregates?.rooms || []).length > 1}
                                updatePresentation={updatePresentation}
                              />
                            ) : (
                              <SchedulePresentation
                                presentation={presentation}
                                isVirtual={isVirtual}
                                show_video_views={show_video_views}
                                showAgenda={(eventData?.aggregates?.rooms || []).length > 1}
                                singlepresentation={() => { setPres(presentation) }}
                                updatePresentation={updatePresentation}
                              />
                            )}
                          </React.Fragment>
                        ));
                    } catch (error) {
                      console.error("Failed to render schedule:", error);
                      return (
                        <ScheduleFallback message="Schedule data is temporarily unavailable. Please refresh and try again." />
                      );
                    }
                  })()}
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      }
      <EditProfileModal
        openProfileModal={openProfileModal}
        setOpenProfileModal={setOpenProfileModal}
      />
    </div>
  );
};

export default Schedule;
